import Vue from 'vue'
import Vuex from 'vuex'

import UserService from './services/userService'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    jPlayer: null
  },
  mutations: {
    api_request (state) {
      state.status = 'loading'
    },
    api_error (state) {
      state.status = 'error'
    },
    api_success (state) {
      state.status = 'success'
    },
    update_jPlayer (state, payload) {
      state.jPlayer = payload.value
    },
    update_is_playing_status (state, payload) {
      state.jPlayer.isPlaying = payload.value
    }
  },
  actions: {
    catchHandler ({ commit }) {
      commit('api_error')
    },

    updateJPlayer ({ commit }, value) {
      commit('update_jPlayer', { value })
    },

    updateIsPlayingStatus ({ commit }, value) {
      commit('update_is_playing_status', { value })
    }
  },
  getters: {
    apiStatus: state => state.status,
    jPlayer: state => state.jPlayer,
    isMusicPlaying: state => state.jPlayer.isPlaying
  },
  modules: {
    UserService
  }
})



// WEBPACK FOOTER //
// ./src/store.js